export const CATEGORY_COLOURS = {
  fuel:        '#006BBB',
  oc:          '#30A0E0',
  tco:         '#6254C7',
  utilization: '#6FC3B2',
  inspections: '#F2A07B',
  maintenance: '#F2A07B',
  workorders:  '#FFC872',
};

export function getCategoryColour(domain) {
  return CATEGORY_COLOURS[domain] ?? '#888888';
}
